// Sob bundlers (esbuild/CommonJS), o UMD do select2 NAO se auto-instala: ele
// exporta uma funcao instaladora que precisa ser chamada para registrar
// $.fn.select2 no jQuery. Sem isso, o arquivo de i18n quebra ao ler
// jQuery.fn.select2.amd (undefined). Este modulo e importado antes do i18n.
import installSelect2 from "select2/dist/js/select2.full.min.js";

// Chamado sem args: internamente faz require("jquery") (mesma instancia do
// bundle, exposta em window.jQuery) e instala o select2 nela.
if (typeof installSelect2 === "function") {
  installSelect2();
}
